import EmojiPicker from "emoji-picker-react";
import React, { useEffect, useRef, useState } from "react";
import { Col, FloatingLabel, Form, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { Assets } from "../../../../../constants/images";
import { maxBounds } from "../../../../../constants/contants";
import { SmileIcon } from "../../../../../constants/svg";
import TagSlider from "../../../../Common/TagSlider";
import CustomSelect from "./../../../../FormFields/CustomSelect";
import { setCreateUpdateModuleTitle } from "../../../../../store/slices/globalSlice";
import { roles as salonRoles } from "../../../../../utils/constants";
import { GetAuthUserLocalStorage } from "../../../../../services/localStorage/localStorage";
import CustomTreeSelect from "../../../../FormFields/CustomTreeSelect";

const FirstStep = ({
  title,
  errors,
  register,
  watch,
  control,
  getValues,
  setValue,
  handleTreeSelectValue,
}) => {
  const dispatch = useDispatch();
  const { categories } = useSelector((state) => state.global);

  const emojiPickerRef = useRef(null);
  const [showPicker, setShowPicker] = useState(false);
  const selectedCategory = watch("category");
  const showPickerShowHide = useRef(false);
  const containerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const recipients = watch ? watch("recipients") : [];
  const recipientType = watch ? watch("recipientType") : "";

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    window.addEventListener("mouseup", handleMouseUp);
    return () => {
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  function handleEmojiClick(emojiData) {
    setValue("quizName", getValues("quizName") + emojiData.emoji);
  }

  const handleCheckEmojiClick = (event) => {
    if (
      emojiPickerRef.current &&
      !emojiPickerRef.current.contains(event.target) &&
      showPicker
    ) {
      setShowPicker(false);
    }
  };

  useEffect(() => {
    window.addEventListener("click", handleCheckEmojiClick);
    return () => {
      window.removeEventListener("click", handleCheckEmojiClick);
    };
  }, [showPicker]);

  return (
    <>
      <Form>
        <Row>
          <Col lg={8}>
            <FloatingLabel
              controlId="quizName"
              label="Quiz Name"
              className="mb-20 custom-textarea"
            >
              <Form.Control
                type="text"
                placeholder="ex. Service Cycle Assessment"
                autoComplete="off"
                role={"presentation"}
                minLength={1}
                maxLength={100}
                className={errors.quizName ? "hasError" : ""}
                {...register("quizName", {
                  onChange: (e) => {
                    dispatch(setCreateUpdateModuleTitle(e.target.value));
                  },
                  required: "Quiz Name is required",
                  minLength: {
                    value: 1,
                  },
                  maxLength: {
                    value: 100,
                  },
                })}
              />
              <div ref={emojiPickerRef}>
                <div
                  onClick={() => {
                    setShowPicker(!showPicker);
                  }}
                  className={"smileyBox"}
                >
                  <img src={Assets.Smile} className={"smileImage"} />
                </div>
                {showPicker && <EmojiPicker onEmojiClick={handleEmojiClick} />}
              </div>
            </FloatingLabel>
          </Col>
          {GetAuthUserLocalStorage()?.roles[0]?.id !==
            salonRoles.super_admin && (
            <Col lg={4}>
              <div className="form-floating">
                <CustomTreeSelect
                  label="Recipients"
                  placeholder="Recipients"
                  defaultSelectedData={recipients}
                  handleChange={handleTreeSelectValue}
                  selectedCategory={
                    recipientType === 1001
                      ? "everyone"
                      : recipientType === 1002
                        ? "group"
                        : recipientType === 1003
                          ? "member"
                          : null
                  }
                />
              </div>
            </Col>
          )}
          <Col lg={4}>
            <Controller
              control={control}
              name="category"
              defaultValue={""}
              rules={{
                required: "Category is required",
              }}
              render={({ field: { onChange, value } }) => (
                <FloatingLabel
                  controlId="category"
                  label={value == "" ? "Category" : ""}
                  className="mb-20"
                >
                  <CustomSelect
                    value={value}
                    label="Category"
                    options={categories.filter((elem) => elem.value != 0)}
                    className={value == "" ? "hasError" : ""}
                    onChange={onChange}
                    placeholder="Category"
                  />
                </FloatingLabel>
              )}
            />
          </Col>
          <Col lg={8} className={`mb-20 ${selectedCategory ? "" : "d-none"}`}>
            <Controller
              control={control}
              name="tags"
              rules={{
                required: "Tag are required",
              }}
              render={({ field: { onChange, onBlur, value, ref } }) => (
                <TagSlider
                  value={value}
                  handleChange={onChange}
                  categoryId={selectedCategory}
                  title={title}
                />
              )}
            />
          </Col>
          <Col lg={12}>
            <FloatingLabel
              controlId="description"
              label="Description (Optional)"
              className="mb-20 custom-textarea"
            >
              <Form.Control
                minLength={0}
                maxLength={999}
                as="textarea"
                placeholder="Improve your coloring knowledge with this quiz."
                style={{ height: "200px" }}
                className={`form-control ${errors.description ? "hasError" : ""}`}
                {...register("description", {
                  required: false,
                  minLength: {
                    value: 0,
                  },
                  maxLength: {
                    value: 999,
                  },
                })}
              />
            </FloatingLabel>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default FirstStep;
